import * as App from '../../weave/index.mjs';
import * as Helper from '../../weave/helpers.mjs';
import axios from 'axios';

class PetersIndex extends App.Index {
    loadList() {
        const formElement = document.querySelector('[name="index"]');
        var formData = new FormData(formElement);

        const url = formElement.action;
        this.loadingSpinner();
        
        // fetch(url, {
        //     body: formData,
        //     method: 'POST'
        // }).then(response => {
        //     return response.text();
        // }).then(text => {
        //     this.setListHtml(text);
        // });

        axios.post(url, formData).then(r => {
            this.setListHtml(r.data);
        });
    }

    repaginate(pagination) {
        pagination.innerHTML = "";
        var showFirst = this.page > 2 ? (this.page > this.totalPages - 3 ? this.totalPages - 4 : this.page - 2) : 1;
        var showLast = this.page > 2 ? (this.page > this.totalPages - 3 ? this.totalPages : this.page + 2) : 5;

        if (showFirst < 1) showFirst = 1;
        if (showLast > this.totalPages) showLast = this.totalPages;

        for (var i=showFirst; i<=showLast; i++) {
            var li = document.createElement('span');
            li.classList.add("page-item", "pageButton", "pageNumber");
            if (this.config.jsPagination) {
                li.addEventListener('click', this.updatePagination.bind(this));
            } else {
                li.addEventListener('click', this.loadList.bind(this));
            }
            if (i == this.page) li.classList.add("active", "current", "selected");
            li.setAttribute('data-page', i);
            li.innerText = i;
            pagination.appendChild(li);
        }

        this.updatePaginationNav();
    }

    reflowPages() {
        if (this.totalPages <= 1) {
            $(".pagination .items").hide();
            return;
        }

        $(".pagination .items").show();
        
        super.reflowPages();
    }

    validateForm(formElement) {
        var valid = true;
        formElement.querySelectorAll("[required]").forEach(el => {
            if (!el.value && $(el).is(":visible")) {
                $(el).addClass("shake animated");
                $(el).parents(".form-split").first().addClass("has-error");
                $(el).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    $(el).removeClass('shake animated');
                });
                valid = false;
            } else {
                $(el).parents(".form-split").first().removeClass("has-error");
            }
        });
        if (!valid) {
            return false;
        }
        return true;
    }

    init() {
        super.init(); 

        if(!window.swiper){
            window.swiper = [];
        }     
        
        $(".datepicker").datepicker({
            showAnim: "fade",
            dateFormat: "dd/mm/yy",
            yearRange: "-10:+0",
            changeMonth: true,
            changeYear: true,
            onSelect: date => {
                this.loadList();
            }
        });
    }

    initCarousels(arrows=true) {

        var recommendedSections = document.querySelectorAll('.recommendedSection');
        var isInitialised = false;
        var isDestroyed = false;

        var carouselBreakpoints = {
            6: {
                1024: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                },
                920: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                769: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                650: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                480: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            },
            8: {
                1024: {
                    slidesPerView: 8,
                    slidesPerGroup: 8,
                },
                920: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
                800: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                600: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                480: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            }
        };

        recommendedSections.forEach(function(section, index) {

            section.id = `recommendedSection${index}`;

            var slider = section.querySelector('.swiper-container');
            var noSlides = parseInt(section.dataset.slides);
            var slidetoshowcount = parseInt(section.getAttribute('slidetoshowcount'));
            
            if(!slider.classList.contains("swiper-container-initialized") && window.innerWidth > 481){
                
                // get minimum 
                var breakpoints = carouselBreakpoints[slidetoshowcount];
                var slidesPerView = slidetoshowcount;
                for (const width in breakpoints) {
                    if(window.innerWidth > width){
                        continue;
                    }else{
                        slidesPerView = breakpoints[width]["slidesPerView"];
                        break;
                    }
                };

                var navigationArrows = arrows ? { nextEl: '.swiper-button-next',  prevEl: '.swiper-button-prev',
                } : false;
                
                
                window.swiper[index] = new Swiper(`#recommendedSection${index} .swiper-container`, {
                    // Disable preloading of all images
                    preloadImages: slidesPerView > noSlides,
                    checkInView: true,
                    // Enable lazy loading
                    lazy: true,
                    watchSlidesVisibility: true,
                    spaceBetween: 10,
                    loop:  noSlides > slidesPerView,
                    centerInsufficientSlides: true,
                    //centeredSlides: slidesPerView > noSlides,
                    navigation: navigationArrows,
                    breakpoints: carouselBreakpoints[slidetoshowcount],
                    on: {
                        beforeInit: function () {
                            section.querySelector(".sliderOverlay").style.display = "block";
                        },
                        init: function () {
                            section.querySelector(".sliderOverlay").style.display = "none";
                        },
                        beforeDestroy: function () {
                            section.querySelector(".sliderOverlay").style.display = "block";
                        },
                        destroy: function () {
                            section.querySelector(".sliderOverlay").style.display = "none";
                        },
                        lazyImageLoad: function (swiper, slideEl, imageEl) {
                            //set backup
                            if(!imageEl.dataset.backupSrc){
                                var imageSrc = imageEl.dataset.src;
                                imageEl.setAttribute("data-backup-src", imageSrc);
                            }

                        },
                        lazyImageReady: function (swiper, slideEl, imageEl) {
                            //use backup to recreate data-src
                            if(imageEl.src && !imageEl.dataset.src){
                                var backupSrc = imageEl.dataset.backupSrc;
                                imageEl.setAttribute("data-src", backupSrc);
                            }

                        },
                        afterInit: function (swiper) {
                            var navHack = false;
                            //Hack for some reason on libraries the next button is disabled.
                            if(swiper.navigation.nextEl && swiper.navigation.nextEl.classList.contains("swiper-button-disabled")){
                                swiper.navigation.nextEl.disabled = false;
                                swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
                                swiper.navigation.nextEl.removeAttribute("aria-disabled"); 
                                navHack = true;                           
                            }

                            if(swiper.navigation.prevEl && swiper.navigation.prevEl.classList.contains("swiper-button-disabled")){
                                swiper.navigation.prevEl.disabled = false;
                                swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
                                swiper.navigation.prevEl.removeAttribute("aria-disabled");  
                                navHack = true;                           
                            }                            

                            if(navHack){
                                swiper.navigation.update();
                            }
                        }
                    },
                });
            } else if (slider.classList.contains("swiper-container-initialized") && window.innerWidth < 480){

                window.swiper[index].destroy(true, true);
                if(index === recommendedSections.length - 1){
                    window.swiper = [];
                }
            } else{
                section.querySelector(".sliderOverlay").style.display = "none";
                
                // lazyload images in mobile grid view
                var visibleSlides = section.querySelectorAll(".swiper-container .swiper-slide:not(:nth-of-type(n + 5))");
                visibleSlides.forEach(slide => {
                    var slideImage = slide.querySelector(".swiper-lazy");
                    slideImage.src = slideImage.dataset.src;
                });
            }
        });

    }
}

export { PetersIndex }